import { Stack } from "@certn/cascadia";
import { css } from "@emotion/css";
import { findUISchema } from "@jsonforms/core";
import { JsonFormsDispatch } from "@jsonforms/react";
import { DeleteButton } from "../DeleteButton";
import { ItemProps } from "../types";
import { ItemHeading } from "../ItemHeading";
import { ItemSubtitle } from "../ItemSubtitle";

export function BaseItem(props: ItemProps) {
  const schema = findUISchema(
    props.uischemas || [],
    props.schema,
    props.uischema.scope,
    props.path,
    undefined,
    props.uischema,
    props.rootSchema
  );

  return (
    <>
      <div className={styles.elementHeading}>
        <Stack orientation="vertical" gap="space-0">
          <ItemHeading {...props} />
          <ItemSubtitle {...props} />
        </Stack>
        <DeleteButton {...props} />
      </div>
      <JsonFormsDispatch
        schema={props.schema}
        uischema={schema}
        path={props.path}
      />
    </>
  );
}

const styles = {
  elementHeading: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }),
};
